import type { HelpFile } from '../../types/help'
import { AssignmentDecisionsTestIds } from '../../../testids/AssignmentDecisionsTestIds'

export const assignmentDecisionsHelp: HelpFile = {
  docPage: '/docs/governance/certification-reviews',
  texts: {
    [AssignmentDecisionsTestIds.assignmentDecisionsPage]:
      'Review every access assignment in this campaign and decide whether each one should be kept or revoked.',
    [AssignmentDecisionsTestIds.cardTitleAllAssignments]:
      'Full list of access assignments under review. Use the per-row buttons to decide each one, or select multiple rows to decide them in bulk.',
    [AssignmentDecisionsTestIds.btnCertify]:
      'Submit all your decisions and finalize the campaign for these assignments.',
    [AssignmentDecisionsTestIds.btnPrevItem]: null,
    [AssignmentDecisionsTestIds.btnNextItem]: null,
    [AssignmentDecisionsTestIds.btnBulkDecide]:
      'Apply the same keep/revoke decision to all selected assignments at once.',
    [AssignmentDecisionsTestIds.bulkBtnKeep]: null,
    [AssignmentDecisionsTestIds.bulkBtnRevoke]:
      'Revoke access for all selected rows — provisioned after the campaign closes.',
    [AssignmentDecisionsTestIds.bulkBtnUndecided]:
      'Reset selected rows to undecided for later review.',
    [AssignmentDecisionsTestIds.inputBulkComment]:
      'Optional comment recorded on every decision in this bulk action — useful for justifying revocations.',
    [AssignmentDecisionsTestIds.colDecision]:
      'Your current decision for the assignment — keep, revoke, or undecided.',
    [AssignmentDecisionsTestIds.assignmentDecisionsCount]: null,
  },
}
